import LogsListHeader from './LogsListHeader';

export default LogsListHeader;
